// FEMPIRE FASHION — Theme JS
// Announcement Bar JS zit inline in sections/announcement-bar.liquid

/* ── Mobile Menu ──────────────────────────────────────────── */
class MobileMenu extends HTMLElement {
  connectedCallback() {
    this.menu    = this.querySelector('.mobile-menu');
    this.toggles = document.querySelectorAll('[data-mobile-menu-toggle]');
    this.close   = this.querySelector('.mobile-menu__close');

    this.toggles.forEach(t => t.addEventListener('click', () => this.open()));
    this.close?.addEventListener('click', () => this.closeMenu());

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.closeMenu();
    });
  }

  open() {
    this.menu?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeMenu() {
    this.menu?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}
customElements.define('mobile-menu', MobileMenu);

/* ── Scroll Fade ──────────────────────────────────────────── */
// Content start op opacity 0 en wordt zichtbaar bij scrollen. Faalt de
// observer (oude browser, reduced motion), dan tonen we alles direct —
// tekst mag nooit permanent onzichtbaar blijven.
(function () {
  const SEL = '.scroll-fade, .image-reveal';
  const revealAll = () =>
    document.querySelectorAll(SEL).forEach(el => el.classList.add('is-visible'));

  const reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reducedMotion) {
    document.addEventListener('DOMContentLoaded', revealAll);
    return;
  }

  // rootMargin -8% onderaan: met de kortere transitie (ronde 3) mag het element
  // later aanmelden en zie je het resultaat, niet de animatie.
  const observer = new IntersectionObserver(
    entries => entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        observer.unobserve(e.target);
      }
    }),
    { threshold: 0, rootMargin: '0px 0px -8% 0px' }
  );

  document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll(SEL);
    items.forEach(el => observer.observe(el));
    // Vangnet: wat al in beeld staat maar niet is aangemeld, alsnog tonen.
    requestAnimationFrame(() => {
      items.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    });
  });
})();

/* ── Product Gallery Thumbs ───────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      if (!gallery) return;
      const mainImg = gallery.querySelector('.product-gallery__main img');
      if (mainImg) mainImg.src = thumb.querySelector('img')?.src;
      gallery.querySelectorAll('.product-gallery__thumb').forEach(t =>
        t.classList.remove('product-gallery__thumb--active')
      );
      thumb.classList.add('product-gallery__thumb--active');
    });
  });
});

/* ── Product variant selectie ─────────────────────────────── */
// Koppelt de optieknoppen aan echte varianten: hidden input, prijs en
// voorraadstatus worden bijgewerkt zodat de klant de gekozen variant bestelt.
document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.getElementById('product-variants-data');
  if (!dataEl) return;

  let variants;
  try { variants = JSON.parse(dataEl.textContent); } catch { return; }

  const variantInput = document.getElementById('variant-id');
  const priceEl      = document.getElementById('product-price');
  const atcBtn       = document.querySelector('.product-info__atc');
  const groups       = Array.from(document.querySelectorAll('.option-buttons'));
  if (!variantInput || !groups.length) return;

  const selectedValues = () =>
    groups.map(g => g.querySelector('.option-btn--active')?.dataset.value ?? null);

  const applyVariant = (variant) => {
    if (!variant) {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Niet beschikbaar'; }
      return;
    }
    variantInput.value = variant.id;
    if (priceEl) {
      priceEl.innerHTML = variant.compare
        ? `<s>${variant.compare}</s> ${variant.price}`
        : variant.price;
    }
    if (atcBtn) {
      if (variant.cents === 0) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Prijs op aanvraag';
      } else if (!variant.available) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Uitverkocht';
      } else {
        atcBtn.disabled = false;
        atcBtn.textContent = 'In winkelwagen';
      }
    }
  };

  groups.forEach(group => {
    group.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.option-btn').forEach(b =>
          b.classList.remove('option-btn--active')
        );
        btn.classList.add('option-btn--active');

        const values = selectedValues();
        const match = variants.find(v =>
          v.options.every((opt, i) => opt === values[i])
        );
        applyVariant(match);
      });
    });
  });
});
